import { Option } from "@morphism/fp";
import React, { type FunctionComponent } from "react";
import { Route, Switch } from "react-router-dom";
import styled from "styled-components";
import { UniversalHeader } from "~/UniversalHeader";
import { useFlags } from 'launchdarkly-react-client-sdk'

import { Company } from "~/Company";
import { Dashboard } from "~/Dashboard";
import * as Document from "~/Document";
import * as Driver from "~/Driver";
import { DVIR, DVIRs } from "~/DVIR";
import * as ELD from "~/ELD";
import { GlobalStyle } from "~/GlobalStyle";
import * as Log from "~/Log";
import { MainMenu } from "~/MainMenu";
import * as Messaging from "~/Messaging";
import * as Preferences from "~/Preferences";
import { UnauthorizedSplash } from '~/UnauthorizedSplash'
import { DVIRsSummary } from "./DVIR/DVIRs/DVIRsSummary";

const Container = styled.div`
    position: absolute;
    top: ${() => UniversalHeader.height()};
    bottom: 0;
    left: ${() => MainMenu.useWidth()};
    right: 0;
    overflow: auto;
    font-weight: 400;
    transition: left ${MainMenu.animationSpeed().duration}ms
    ${MainMenu.animationEase()};
`;

export const AppRouter: FunctionComponent= () => {
    const { disableElogsAccess } = useFlags()

    Preferences.Get.usePrefetch();
    Company.Assets.usePrefetch();

    if ( disableElogsAccess ) {
        return (
          <UnauthorizedSplash />
        )
    }

    return (
        <>
            <Container>
                <Switch>
                <Route exact strict path={Dashboard.Route.definition()}>
                    <Dashboard />
                </Route>
                <Route exact strict path={Driver.AddEdit.Route.definition("add")}>
                    <Driver.AddEdit />
                </Route>
                <Route path={Driver.AddEdit.Route.definition("edit")}>
                    <Driver.AddEdit driver={Option.toUndefined(Driver.useReferenceFromRoute())} />
                </Route>
                <Route exact path={Log.Route.definition()}>
                    <Log.Component />
                </Route>
                <Route exact path={Driver.Overview.Route.initialDefinition()}>
                    <Driver.Overview />
                </Route>
                <Route path={Driver.Page.Route.definition()}>
                    <Driver.Page />
                </Route>
                <Route exact strict path={Log.Unassigned.Route.definition()}>
                    <Log.Unassigned.Page.Component />
                </Route>
                <Route path={Log.Route.definition()}>
                    <Driver.Page />
                </Route>
                <Route path={Log.Summaries.Page.Route.definition()}>
                    <Log.Summaries.Page />
                </Route>
                <Route path={ELD.Route.definition()}>
                    <ELD.Page.Component />
                </Route>
                <Route path={Document.Route.definition()}>
                    <Document.Page.Component />
                </Route>
                <Route path={DVIR.Missing.Route.definition()}>
                    <DVIR.Missing />
                </Route>
                <Route path={DVIRs.Route.WithoutInterval.definition()}>
                    <DVIRsSummary />
                </Route>
                <Route path={Messaging.Route.definition()}>
                    <Messaging.Page.Component />
                </Route>
                </Switch>
            </Container>
            <GlobalStyle />
            <UniversalHeader />
            <MainMenu />
        </>
    );
}
